import styled from "styled-components";
import {devices} from "../../config/Breakpoints";
import { Tabs, Tab } from "@mui/material";
import MuiBlock from "../../atom/MuiCustoms";
import { useEffect, useState } from "react";

const CustomTabs = styled(Tabs)`
    &.withScroll {
        max-width: 53rem;
        border: 1px solid var(--color-lightGray);
        border-radius: 999px;
        margin: 0 auto;
    }

    &.withoutScroll {
        .MuiTabs-scroller {    
            display: flex;
            margin: 0 auto;
            justify-content: center;
        }
        .MuiTabs-centered {
            justify-content: center;
            border: 1px solid var(--color-lightGray);
            border-radius: 999px;
            padding: 0 2rem;
        }
    }
    
    // border: 1px solid var(--color-lightGray);
    // margin: 0 auto;
    // border-radius: 999px;
`;

const CustomTab = styled(Tab)`
    text-transform: none;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    position: relative;

    & > .tabLabel:after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 1rem;
        width: 1px;
        background: var(--color-lightGray);
    }

    &:last-child > .tabLabel:after {
        display: none;
    }
`;

const RaffleTab = ({promoData, handleChange}) => {
    const [currentValue, setCurrentValue] = useState(0);
    const [variantValue, setVariantValue] = useState('standard');

    const changeEv = (ev, newValue) => {
        if(handleChange) {
            handleChange(newValue);
        }
        setCurrentValue(newValue);
    }

    useEffect(() => {
        promoData.raffles.forEach((item, index) => {
            if(item.isNextRaffle) {
                setCurrentValue(index);
                return;
            }
        });
        setVariantValue(
            window.innerWidth >= devices.md ?
                (promoData.raffles.length > 6 ? 'scrollable' : 'standard') :
                (window.innerWidth >= devices.sm ? 
                    (promoData.raffles.length > 4 ? 'scrollable' : 'standard') : 
                    (promoData.raffles.length > 2 ? 'scrollable' : 'standard')
                )
        );
    },[promoData]);

    return (
        <>
            {promoData.raffles.length > 1 && (
                <MuiBlock>
                    <CustomTabs
                        value={currentValue}
                        onChange={changeEv}
                        variant={variantValue}
                        allowScrollButtonsMobile
                        scrollButtons
                        centered={variantValue === 'standard'}
                        sx={variantValue === 'standard' ? {flex: 'initial'} : {}}
                        className={variantValue === 'standard' ? 'withoutScroll' : 'withScroll'}
                    >
                        {promoData.raffles.map((item, index) => (
                            <CustomTab label={<span className='tabLabel'>{item.name}</span>} key={`promoRaffle_${index}`} />
                        ))}
                    </CustomTabs>
                </MuiBlock>
            )}
        </>
    )
};

export default RaffleTab;